export default "__VITE_ASSET__IftSS1hy__"